import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.js"; // ✅ Extension ajoutée

window.addEventListener("error", (event) => {
  console.error("🛑 Global Error:", event.message, event.error);
});

window.addEventListener("unhandledrejection", (event) => {
  console.error("🛑 Unhandled Promise Rejection:", event.reason);
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);